import {
  getApiV2Client,
  getSegmentsGetSegmentAudioUrl,
  segmentsGetSegmentsSequence,
} from '@mi-front/api-v2';
import {
  ISegmentsApi,
  Milliseconds,
  SegmentsSequence,
  Timestamp,
  toDateTimeStr,
  toTimestamp,
} from '@mi-front/core';

/**
 * api-v2-backed segments client for audio playback providers and cache warmers.
 * Maps sequence DTOs into the `MinimumSegment` shape expected by SegmentsAudioPlayer.
 */
export const apiV2SegmentsApi: ISegmentsApi = {
  async fetchSequence(stationId: string, timestamp: Timestamp): Promise<SegmentsSequence> {
    const { segments } = await segmentsGetSegmentsSequence(stationId, timestamp);

    return segments.map((segment) => ({
      id: segment.id,
      startTs: toTimestamp(segment.startTs),
      endTs: toTimestamp(segment.endTs),
      duration: (segment.endTs - segment.startTs) as Milliseconds,
      datetime: toDateTimeStr(segment.startTs),
    }));
  },

  async fetchSegmentAudio(stationId: string, segmentId: number): Promise<ArrayBuffer> {
    const { data } = await getApiV2Client().request<ArrayBuffer>(
      'GET',
      getSegmentsGetSegmentAudioUrl(stationId, segmentId).url,
      { responseType: 'arraybuffer' },
    );

    return data;
  },

  generateAudioURL(stationId: string, segmentId: number): string {
    return getApiV2Client().generateUrl(getSegmentsGetSegmentAudioUrl(stationId, segmentId).url, {
      secure: true,
    });
  },
};
